/**
 * UTM parameter capture helpers.
 * Call captureUtmParams() on the landing/splash screen mount.
 * Call getUtmParams() anywhere to read them back (e.g. at registration).
 */

const UTM_STORAGE_KEY = "britannia_utm";

/**
 * Reads utm_source, utm_medium, utm_campaign from the current URL
 * and persists them in sessionStorage. Safe to call multiple times;
 * only overwrites if new values are found.
 */
export function captureUtmParams() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utm = {
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
    };
    // Only store if at least one value is present
    if (utm.utm_source || utm.utm_medium || utm.utm_campaign) {
      sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utm));
    }
  } catch (_) {
    // sessionStorage blocked (private browsing edge cases) — silently ignore
  }
}

/**
 * Returns the stored UTM params, or an object of empty strings if none.
 */
export function getUtmParams() {
  try {
    const raw = sessionStorage.getItem(UTM_STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch (_) {
    // ignore
  }
  return { utm_source: "", utm_medium: "", utm_campaign: "" };
}
